import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  FormHelperText,
  Input,
  Select,
  Box,
  Flex,
  Text,
  Button,
  Card,
  CardBody,
  SimpleGrid,
  Textarea,
  CardHeader,
  CardFooter,
  Image,
} from "@chakra-ui/react";
import { toast } from "react-hot-toast";
import image from "../../assets/img/carousel-1.jpg";
import image1 from "../../assets/img/room-1.jpg";
import room1 from "../../assets/img/room-1.jpg";
import room2 from "../../assets/img/room-2.jpg";
import room3 from "../../assets/img/room-3.jpg";
import room4 from "../../assets/img/room-1.jpg";
import room5 from "../../assets/img/room-2.jpg";
import room6 from "../../assets/img/room-3.jpg";
import ShowTodo from "../../modules/billing/AddFood";
import TextField from "../../modules/billing/TextField";
import "react-calendar/dist/Calendar.css";
import Calendar from "react-calendar";
import { useReactToPrint } from "react-to-print";
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { checkboxClasses } from "@mui/material";
import { useLocation } from "react-router-dom";

const RoomBilling = () => {
  const location = useLocation();
  const { roomNo, registration } = location.state || {};
  const componentRef = useRef();
  const [data, setData] = useState([]);
  const [otherRate, setOtherRate] = useState([]);
  const [totalAmountRAte, setTotalAmountRate] = useState([]);
  const [roomBill, setRoomBill] = useState([]);
  const [printData, setPrintData] = useState([]);
  const [serviceGst, setServiceGst] = useState([]);
  const [service, setService] = useState([]);
  const [services, setServices] = useState([]);
  const [serviceBill, setServiceBill] = useState([]);
  const [roomBook, setRoomBook] = useState([]);
  // const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]); // State for selected date

  const customerId = localStorage.getItem("customerId");

  const fetchOtherRate = async () => {
    try {
      const response = await axios.get(
        `https://api.hotel.launchlysoftware.in/api/getOtherRoomRate/${customerId}`,
      );
      setOtherRate(response.data.otherRoomRate);
    } catch (error) {
      toast.error("Failed to fetch other room rate data");
    }
  };
  const fetchServiceData = async () => {
    try {
      const response = await axios.get(
        `https://api.hotel.launchlysoftware.in/api/getRoomService/${customerId}`,
      );
      setServices(response.data.roomService);
      console.log(response.data.roomService);
    } catch (error) {
      //toast.error(error.message)
    }
  };
  const fetchMergeBillData = async () => {
    const response = await axios.get(
      `https://api.hotel.launchlysoftware.in/api/getMergedData/${customerId}`,
    );
    setService(response.data);
  };
  const formatTimeToAMPM = (time) => {
    const formattedTime = new Date(`6000-01-01T${time}`);
    return formattedTime.toLocaleString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  };
  // console.log(customerId)
  const fetchData = async () => {
    const response = await axios.get(
      `https://api.hotel.launchlysoftware.in/api/getRoomdata/${customerId}`,
    );
    setData(response.data.room);
  };
  const fetchRoomData = async () => {
    const response = await axios.get(
      `https://api.hotel.launchlysoftware.in/api/getRoomBookData/${customerId}`,
    );
    setRoomBook(response.data.room);
  };

  const fetchRoomBill = async () => {
    try {
      const response = await axios.get(
        `https://api.hotel.launchlysoftware.in/api/getRoomBillData/${customerId}`,
      );
      if (response.data.length > 0) {
        setRoomBill(response.data[response.data.length - 1]); // use last record
      } else {
        setRoomBill(null);
      }
    } catch (error) {
      console.error("Failed to fetch room bill data");
    }
  };

  const fetchData3 = async () => {
    try {
      const response = await axios.get(
        `https://api.hotel.launchlysoftware.in/api/getPrintData/${customerId}`,
      );
      const rooms = response.data;

      // Map over rooms and fetch images dynamically
      const updatedRooms = await Promise.all(
        rooms.map(async (room) => {
          if (room.image) {
            const imageResponse = await axios.get(
              `https://api.hotel.launchlysoftware.in/get-image/${room.image}`,
              {
                responseType: "blob", // Assuming image is returned as a blob
              },
            );

            // Create a URL for the image blob
            room.imageUrl = URL.createObjectURL(imageResponse.data);
          } else {
            room.imageUrl = null; // Handle cases where image is missing
          }
          return room;
        }),
      );

      console.log(updatedRooms, "updatedRooms");
      setPrintData(updatedRooms);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  // console.log(data);

  const array = [
    {
      roomNo: 100,
      floorNo: 1,
      category: "Double",
      type: "Deluxe",
      rate: 1000,
      sgst: 5,
      cgst: 5,
      src: room1,
    },
    {
      roomNo: 101,
      floorNo: 1,
      category: "Single",
      type: "Non-Deluxe",
      rate: 500,
      sgst: 5,
      cgst: 5,
      src: room2,
    },
    {
      roomNo: 102,
      floorNo: 1,
      category: "Double",
      type: "Deluxe",
      rate: 1500,
      sgst: 5,
      cgst: 5,
      src: room3,
    },
    {
      roomNo: 200,
      floorNo: 2,
      category: "Double",
      type: "Deluxe",
      rate: 2000,
      sgst: 5,
      cgst: 5,
      src: room4,
    },
    {
      roomNo: 201,
      floorNo: 2,
      category: "Single",
      type: "Non-Deluxe",
      rate: 1000,
      sgst: 5,
      cgst: 5,
      src: room5,
    },
    {
      roomNo: 202,
      floorNo: 2,
      category: "Double",
      type: "Deluxe",
      rate: 2000,
      sgst: 5,
      cgst: 5,
      src: room6,
    },
    {
      roomNo: 300,
      floorNo: 3,
      category: "Double",
      type: "Deluxe",
      rate: 3000,
      sgst: 5,
      cgst: 5,
      src: room1,
    },

    {
      roomNo: 301,
      floorNo: 3,
      category: "Single",
      type: "Non-Deluxe",
      rate: 2000,
      sgst: 5,
      cgst: 5,
      src: room2,
    },
    {
      roomNo: 302,
      floorNo: 3,
      category: "Double",
      type: "Deluxe",
      rate: 3000,
      sgst: 5,
      cgst: 5,
      src: room3,
    },
  ];
  // const calculateNumberOfDays = (checkIn, checkOut) => {
  //   const startDate = new Date(checkIn);
  //   const endDate = new Date(checkOut);
  //   const differenceInTime = endDate.getTime() - startDate.getTime();
  //   const differenceInDays = differenceInTime / (1000 * 3600 * 24);
  //   return differenceInDays;
  // };
  const [filteredRooms, setFilteredRooms] = useState([...array]);
  const [formData, setFormData] = useState({
    name: "",
    registration: registration ? registration : "",
    date: new Date().toISOString().split("T")[0],
    address: "",
    phoneNo: "",
    companyName: "",
    gstNo: "",
    checkIn: "",
    checkInTime: "",
    checkOut: "",
    checkOutTime: "",
    roomSelect: "",
    roomNo: "",
    billNo: "",
    rate: 0,
    sgst: 0,
    cgst: 0,
    total: 0,
    discount: 0,
    serviceCharge: 0,
  });
  const [submittedData, setSubmittedData] = useState([]);
  // const handleIdentityChange = (e) => {
  //   const selected = data.find(item => item.name === e.target.value);
  //   if (selected) {
  //     setFormData({
  //       ...formData,
  //       name:selected.name,
  //   registartion:selected.registartion,
  //   date:selected.date,
  //   address:selected.address,
  //   phoneNo:selected.phoneNo,
  //   gstNo:selected.gstNo,
  //   checkIn:selected.checkIn,
  //   checkInTime:selected.checkInTime,
  //   checkOut:selected.checkOut,
  //   checkOutTime:selected.checkOutTime,

  //   roomNo: selected.roomNo,

  //     });
  //   }
  // }
  // console.log(roomBook,"roomBook")
  const validateForm = () => {
    const requiredFields = [
      "name",
      "registration",
      "date",
      "address",
      "phoneNo",

      "checkIn",

      "checkOut",
    ];

    for (const field of requiredFields) {
      if (!formData[field]) {
        return false;
      }
    }
    return true;
  };
  // const filterData = () => {
  //   // Assuming roomBook is an array and formData is an object
  //   const filteredRoom = roomBook.find((room) => room.registration === formData.registration);
  //   console.log(filteredRoom,"filteredRoom")
  //   if (filteredRoom) {
  //     setFormData({
  //       ...formData,
  //       registration:filteredRoom.registration,
  //       name: filteredRoom.name,

  //   address:filteredRoom.address,
  //   phoneNo:filteredRoom.phoneNo,
  //   gstNo:filteredRoom.gstNo,
  //   checkIn:filteredRoom.checkIn,

  //   checkOut:filteredRoom.checkOut,
  //   roomSelect:filteredRoom.roomNo

  //     });
  //   }
  // };
  console.log(services, "services");
  const filterData = () => {
    // Assuming roomBook is an array and formData is an object
    const filteredRooms = roomBook.filter(
      (room) => room.registration === formData.registration,
    );
    const filteredServiceBills = service?.filter(
      (item) => item.registration === formData.registration,
    );
    const Roomservices = filteredServiceBills[0]?.roomService;
    const gst = Roomservices
      ? Roomservices.filter((item) => item.gst === true) // Only process items where gst is true
          .map((item) =>
            services
              .filter(
                (service) => service.roomServiceName === item.roomServiceName,
              )
              .reduce(
                (acc, b) => acc + b.roomServicePrice * (b.cgst / 100 || 0),
                0,
              ),
          )
          .reduce((sum, val) => sum + val, 0)
      : 0; // Sum up all calculated values

    console.log(gst, "gst"); // Expected output: 2400

    //setFilterService(Roomservices)
    setServiceGst(gst);

    const totalServiceBill = Roomservices
      ? Roomservices.reduce((acc, item) => {
          return parseInt(acc) + parseInt(item.roomServicePrice);
        }, 0)
      : 0;
    setServiceBill(totalServiceBill + gst * 2);
    console.log(filteredRooms, "filteredRooms");

    if (filteredRooms.length > 0) {
      setFilteredRooms(filteredRooms);
      const roomNumbers = filteredRooms.map((room) => room.roomNo).join(", ");
      let rooms = filteredRooms.map((room) => room.roomNo);
      let totalRate = 0;
      let totalCgst = 0;
      let totalSgst = 0;
      if (filteredRooms[0].singleRate === true) {
        for (let room of rooms) {
          let selected = data.find((item) => item.roomNo === room);
          // console.log(selected,"selected")
          // console.log(otherRate,"otherRate")
          let rateData = otherRate.find(
            (item) => item.category === selected.category,
          );
          //  console.log(rateData,"rateData")
          if (rateData) {
            totalRate += rateData.singleRoomRate;
            totalCgst += rateData.singleRoomRate * 0.025;
            totalSgst += rateData.singleRoomRate * 0.025;
          }
        }
      } else {
        for (let room of rooms) {
          let selected = data.find((item) => item.roomNo === room);
          if (selected) {
            totalRate += selected.rate; // Assuming 'rate' is the property for the room rate
            totalCgst += selected.cgst; // Assuming 'rate' is the property for the room rate
            totalSgst += selected.sgst; // Assuming 'rate' is the property for the room rate
            //   console.log(selected, "selected");
          }
        }
      }
      if (filteredRooms[0].withBreakfast === true) {
        for (let room of rooms) {
          let selected = data.find((item) => item.roomNo === room);
          let rateData = otherRate.find(
            (item) => item.category === selected.category,
          );
          if (rateData) {
            totalRate += rateData.breakfastRate;
            totalCgst += rateData.breakfastRate * 0.025;
            totalSgst += rateData.breakfastRate * 0.025;
          }
        }
      } else if (filteredRooms[0].withBreakfastLunchDinner === true) {
        for (let room of rooms) {
          let selected = data.find((item) => item.roomNo === room);
          let rateData = otherRate.find(
            (item) => item.category === selected.category,
          );
          if (rateData) {
            totalRate += rateData.breakfastwithLunchAndDinnerRate;
            totalCgst += rateData.breakfastwithLunchAndDinnerRate * 0.025;
            totalSgst += rateData.breakfastwithLunchAndDinnerRate * 0.025;
          }
        }
      } else if (filteredRooms[0].withLunchDinner === true) {
        for (let room of rooms) {
          let selected = data.find((item) => item.roomNo === room);
          let rateData = otherRate.find(
            (item) => item.category === selected.category,
          );
          if (rateData) {
            totalRate += rateData.breakfastwithLunchRate;
            totalCgst += rateData.breakfastwithLunchRate * 0.025;
            totalSgst += rateData.breakfastwithLunchRate * 0.025;
          }
        }
      }
      if (filteredRooms[0].extraPerson === true) {
        for (let room of rooms) {
          let selected = data.find((item) => item.roomNo === room);
          let rateData = otherRate.find(
            (item) => item.category === selected.category,
          );
          if (rateData) {
            totalRate += rateData.extraPersonRate;
            totalCgst += rateData.extraPersonRate * 0.025;
            totalSgst += rateData.extraPersonRate * 0.025;
          }
        }
      }
      setTotalAmountRate(totalRate);

      // console.log(roomRates, "roomRates");
      // Set the filtered rooms in a state variable
      // console.log(filteredRooms, "filteredRooms[0]");
      // Optionally, you can set the form data with the first matched room's details
      setFormData({
        ...formData,
        registration: filteredRooms[0].registration,
        name: filteredRooms[0].name,
        address: filteredRooms[0].address,
        phoneNo: filteredRooms[0].phoneNo,
        gstNo: filteredRooms[0].gstNo,
        checkIn: filteredRooms[0].checkIn,
        checkOut: filteredRooms[0].checkOut,

        roomSelect: roomNumbers,
        rate: totalRate,
        sgst: totalSgst,
        cgst: totalCgst,
        roomNo: roomNumbers,
      });
    } else {
      // Handle the case where no matching rooms are found
      console.log("No matching rooms found");
    }
  };
  console.log(roomBook, "roomBook");

  const handleRoomChange = (e) => {
    const value = e.target.value;

    if (!data || !Array.isArray(data)) return;

    const selected = data.find((item) => String(item.roomNo) === String(value));

    if (!selected) return;

    setFormData((prev) => ({
      ...prev,
      roomNo: selected.roomNo,
      rate: selected.rate ?? 0,
      sgst: selected.sgst ?? 0,
      cgst: selected.cgst ?? 0,
      image: selected.image ?? "", // 👈 NEVER null
    }));
  };

  const resName = printData.map((item) => {
    return item.name;
  });
  console.log(resName, "resName");
  const restaurentName = resName.toString();
  console.log(typeof restaurentName, restaurentName, "restaurentName");
  // let latestBillNo;
  console.log(roomBill, "roomBill");
  let latestBillNo = null;
  if (Array.isArray(roomBill) && roomBill.length > 0) {
    for (let i = roomBill.length - 1; i >= 0; i--) {
      if (roomBill[i]?.billNo) {
        latestBillNo = roomBill[i].billNo;
        break;
      }
    }
  }
  console.log(latestBillNo, "latestBillNo");

  const generateBillNo = (latestBillNo, resName) => {
    const year = new Date().getFullYear(); // Get the current year

    // Extract initials from the restaurant name
    const getInitials = (name) => {
      const ignoreWords = ["and", "of", "the", "in", "&", "at"];

      return name
        .split(" ") // Split the name by spaces
        .filter((word) => !ignoreWords.includes(word.toLowerCase())) // Exclude ignored words
        .slice(0, 2) // Take only the first two valid words
        .map((word) => word[0]) // Take the first letter of each word and convert to uppercase
        .join(""); // Join the initials to form the prefix
    };

    const prefix = `${getInitials(resName)}-${year}-RB-`;
    // Create the prefix

    // If there is a latest bill number, extract the numeric part and increment it
    if (latestBillNo) {
      const parts = latestBillNo.split("-");
      const lastPart = parts[parts.length - 1]; // Get the last part of the split string
      const lastNumber = parseInt(lastPart, 10); // Get the last part of the billNo
      const newNumber = lastNumber + 1;
      return `${prefix}${newNumber}`; // Increment and return the new bill number
    }
    console.log(prefix, "prefix");

    // If no previous bill number, start from '1'
    return `${prefix}1`;
  };
  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      rate: formData.rate
        ? parseInt(totalAmountRAte) -
          parseInt(formData.discount ? formData.discount : 0 || 0)
        : 0,
    }));
  }, [formData.discount]);
  const newBillNo = generateBillNo(latestBillNo, restaurentName);
  // console.log(data,"data")
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // useEffect(()=>{
  //   fetchData()
  //   if(formData !== submittedData){
  //     handleSubmit();
  //   }
  // },[formData,submittedData])

  const time = printData[0]?.checkoutTime;
  console.log(typeof printData[0], "time");
  function calculateNumberOfDays(
    checkIn,
    checkOut,
    checkOutTime,
    thresholdTime,
  ) {
    const checkInDate = new Date(checkIn);
    const checkOutDate = new Date(checkOut);

    // Calculate the difference in days
    let numberOfDays = Math.ceil(
      (checkOutDate - checkInDate) / (1000 * 60 * 60 * 24),
    );

    // Parse checkOutTime
    const parseTime = (time) => {
      if (!time || typeof time !== "string" || !time.includes(":")) {
        console.warn("Invalid time passed to parseTime:", time);
        return { hours: 0, minutes: 0 }; // Default fallback
      }

      const [timePart, meridian] = time.trim().split(" ");
      let [hours, minutes] = timePart.split(":").map(Number);

      if (meridian?.toUpperCase() === "PM" && hours !== 12) {
        hours += 12;
      }
      if (meridian?.toUpperCase() === "AM" && hours === 12) {
        hours = 0;
      }

      return { hours, minutes };
    };

    const checkOutParsed = parseTime(checkOutTime);
    const thresholdParsed = parseTime(thresholdTime);

    // Compare checkOutTime with thresholdTime
    const checkOutExceedsThreshold =
      checkOutParsed.hours > thresholdParsed.hours ||
      (checkOutParsed.hours === thresholdParsed.hours &&
        checkOutParsed.minutes > thresholdParsed.minutes);

    // Add an extra day if checkOutTime exceeds the threshold
    if (checkOutExceedsThreshold) {
      numberOfDays += 1;
    }

    return numberOfDays;
  }

  const handleSubmit = (e) => {
    if (!validateForm()) {
      toast.error("Please fill in all required fields.");
      return;
    }
    e.preventDefault();

    console.log(
      formData.checkIn,
      formData.checkOut,
      formData.checkOutTime,
      time,
    );
    const numberOfDays = calculateNumberOfDays(
      formData.checkIn,
      formData.checkOut,
      formData.checkOutTime,
      time,
    );
    console.log(time, "time");
    console.log("Number of days:", numberOfDays);
    // Process formData here, such as sending it to a server
    // console.log("Form submitted with data:", formData);

    const totalSum =
      (numberOfDays == 0 ? 1 : numberOfDays) *
      (formData.rate + formData.rate * 0.025 + formData.rate * 0.025);

    // setFormData((prev) => ({
    //   name:formData.name,
    //   registration:formData.registration,
    //   date:formData.date,
    //   address:formData.address,
    //   phoneNo:formData.phoneNo,
    //   gstNo:formData.gstNo,
    //   checkIn:formData.checkIn,
    //   checkInTime:formatTimeToAMPM(formData.checkInTime),
    //   checkOut:formData.checkOut,
    //   checkOutTime:formatTimeToAMPM(formData.checkOutTime),

    //     roomNo: formData.roomNo,
    //     billNo:newBillNo,
    //     rate:numberOfDays* prev.rate,
    //     sgst:numberOfDays* formData.rate*0.06,
    //     cgst: numberOfDays* formData.rate*0.06,

    //     total:totalSum,

    //   }));
    const updatedFormData = {
      ...formData,
      rate: (numberOfDays == 0 ? 1 : numberOfDays) * formData.rate,
      billNo: newBillNo,
      checkInTime: formatTimeToAMPM(formData.checkInTime),
      checkOutTime: formatTimeToAMPM(formData.checkOutTime),
      sgst: (numberOfDays == 0 ? 1 : numberOfDays) * formData.rate * 0.025,
      cgst: (numberOfDays == 0 ? 1 : numberOfDays) * formData.rate * 0.025,
      serviceCharge: serviceBill,
      total: totalSum + serviceBill,
    };
    setSubmittedData(updatedFormData);
    setFormData(updatedFormData);
    toast.success("Bill Generated Successfully");
    return formData;
  };
  console.log(formData.cgst, formData.sgst, "formData");
  useEffect(() => {
    fetchData();
    fetchRoomData();
    fetchData3();
    fetchRoomBill();
    fetchOtherRate();
    fetchServiceData();
    fetchMergeBillData();
  }, [customerId]);
  let arr = Object.entries(formData);
  console.log(serviceBill, "serviceBill");
  // console.log("arr"+arr)
  const save = async (e) => {
    if (!validateForm()) {
      toast.error("Please fill in all required fields.");
      return;
    }
    //setFormData((prev)=>({...prev,billNo:newBillNo}))
    e.preventDefault();
    try {
      const response = await axios.post(
        "https://api.hotel.launchlysoftware.in/api/roomBill",
        {
          customerId: customerId,
          data: formData,
        },
      );
      //console.log('Data Submitted: ',response.data);
      toast.success(response.data.message);
    } catch (error) {
      if (error.response && error.response.status === 400) {
        // Handle specific error case: Room booking already exists
        toast.error(
          "Room billing already exists for this registration number.",
        );
      } else {
        // console.error("Error:", error);
        toast.error("Failed to bill room. Please try again later.");
      }
    }
  };
  useEffect(() => {
    const roomNo = localStorage.getItem("selectedRoomNo");
    if (!roomNo) return;

    const fetchRoomBill = async () => {
      try {
        const res = await axios.get(
          `https://api.hotel.launchlysoftware.in/api/getRoomDataByNo/${customerId}/${roomNo}`,
        );

        // Set rate into formData
        setFormData((prev) => ({
          ...prev,
          rate: res.data.rate, // assign rate from api
        }));
      } catch (error) {
        console.log(error);
      }
    };

    fetchRoomBill();
  }, []);

  return (
    <Box
      bg="#EAE5DF"
      columns={{ sm: 2, md: 4 }}
      spacing="8"
      p="10"
      textAlign="center"
      color="black"
      width="100%"
      height="fit-content"
    >
      <FormControl isRequired onSubmit={handleSubmit}>
        <Box display="grid" gridGap={1}>
          <Box
            width="full"
            display="flex"
            alignItems="center"
            boxShadow="xl"
            borderRadius="5px"
            p={4}
            justifyContent="center"
            gap="5px"
            mb="6"
          >
            <FormLabel>RegistrationNo</FormLabel>
            <Input
              w="38%"
              bg="#FAFAFA"
              placeholder="Enter Registration"
              name="registration"
              value={formData.registration}
              onChange={handleInputChange}
            />
            <Button
              variant="solid"
              mr={4}
              color="#0F172B"
              bg="#42B1CD"
              _hover={{ color: "white" }}
              onClick={filterData}
            >
              Search
            </Button>
          </Box>
          <Text size="2xl"> RoomNo-{formData.roomSelect}</Text>
          <Box
            display="flex"
            gap="10px"
            alignItems="center"
            justifyContent="space-evenly"
          >
            <Box
              width="40%"
              display="flex"
              alignItems="center"
              boxShadow="xl"
              borderRadius="5px"
              p={4}
            >
              <FormLabel>Guest Name</FormLabel>
              <Input
                w="70%"
                bg="#FAFAFA"
                placeholder="Enter Guest Name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
              />
            </Box>
            <Box
              width="40%"
              display="flex"
              alignItems="center"
              boxShadow="xl"
              borderRadius="5px"
              p={4}
            >
              <FormLabel>Date</FormLabel>
              <Input
                w="80%"
                bg="#FAFAFA"
                type="date"
                placeholder="Enter Date"
                name="date"
                value={formData.date}
                onChange={handleInputChange}
              />
            </Box>
          </Box>
          <Box
            display="flex"
            gap="10px"
            alignItems="center"
            justifyContent="space-evenly"
          >
            <Box
              width="40%"
              display="flex"
              alignItems="center"
              boxShadow="xl"
              borderRadius="5px"
              p={4}
            >
              <FormLabel>Address</FormLabel>
              <Input
                w="70%"
                bg="#FAFAFA"
                placeholder="Enter Address"
                name="address"
                value={formData.address}
                onChange={handleInputChange}
              />
            </Box>
            <Box
              width="40%"
              display="flex"
              alignItems="center"
              boxShadow="xl"
              borderRadius="5px"
              p={4}
            >
              <FormLabel>Phone No</FormLabel>
              <Input
                w="70%"
                bg="#FAFAFA"
                placeholder="Enter Phone no"
                name="phoneNo"
                value={formData.phoneNo}
                onChange={handleInputChange}
              />
            </Box>
          </Box>
          <Box
            display="flex"
            gap="10px"
            alignItems="center"
            justifyContent="space-evenly"
          >
            <Box
              width="40%"
              display="flex"
              alignItems="center"
              boxShadow="xl"
              borderRadius="5px"
              p={4}
            >
              <FormLabel>Company Name</FormLabel>
              <Input
                w="70%"
                bg="#FAFAFA"
                placeholder="Enter Company Name"
                name="companyName"
                value={formData.companyName}
                onChange={handleInputChange}
              />
            </Box>
            <Box
              width="40%"
              display="flex"
              alignItems="center"
              boxShadow="xl"
              borderRadius="5px"
              p={4}
            >
              <FormLabel>Company Gst No</FormLabel>
              <Input
                w="70%"
                bg="#FAFAFA"
                placeholder="Enter Company GstNo"
                name="gstNo"
                value={formData.gstNo}
                onChange={handleInputChange}
              />
            </Box>
          </Box>
          <Box
            display="flex"
            gap="10px"
            alignItems="center"
            justifyContent="space-evenly"
          >
            {/* <Box width="40%" display="flex" alignItems="center" boxShadow='xl' borderRadius="5px" p={4}>
                <FormLabel>Company Gst No</FormLabel>
                <Input bg='#FAFAFA' placeholder="Enter Company GstNo" name='gstNo' value={formData.gstNo} onChange={handleInputChange} />
              </Box> */}
            <Box
              width="40%"
              display="flex"
              alignItems="center"
              boxShadow="xl"
              borderRadius="5px"
              p={3}
            >
              <FormLabel>ChechkIn</FormLabel>
              <Input
                w="35%"
                bg="#FAFAFA"
                type="date"
                placeholder="Enter CheckIn"
                name="checkIn"
                value={formData.checkIn}
                onChange={handleInputChange}
              />
              <Input
                w="35%"
                bg="#FAFAFA"
                type="time"
                placeholder="Enter CheckIn"
                name="checkInTime"
                value={formData.checkInTime}
                onChange={handleInputChange}
              />
            </Box>
            <Box
              width="40%"
              display="flex"
              alignItems="center"
              boxShadow="xl"
              borderRadius="5px"
              p={3}
            >
              <FormLabel>ChechkOut</FormLabel>
              <Input
                w="35%"
                bg="#FAFAFA"
                type="date"
                placeholder="Enter CheckOut"
                name="checkOut"
                value={formData.checkOut}
                onChange={handleInputChange}
              />
              <Input
                w="35%"
                bg="#FAFAFA"
                type="time"
                placeholder="Enter CheckIn"
                name="checkOutTime"
                value={formData.checkOutTime}
                onChange={handleInputChange}
              />
            </Box>
          </Box>

          <Flex
            display="flex"
            gap="10px"
            alignItems="center"
            justifyContent="space-evenly"
          ></Flex>
          <Box
            display="flex"
            gap="10px"
            alignItems="center"
            justifyContent="space-evenly"
          >
            <Box
              width="30%"
              display="flex"
              flexDirection="row"
              alignItems="center"
              boxShadow="xl"
              borderRadius="5px"
              p={4}
            >
              <FormLabel>Room No</FormLabel>
              <Input
                w="70%"
                bg="#FAFAFA"
                placeholder="Enter Room No"
                name="roomSelect"
                value={formData.roomSelect}
                onChange={handleRoomChange}
              />
            </Box>
            {/* <FormLabel>Category</FormLabel>
                <Select bg='#FAFAFA' placeholder="Category" name='category' value={formData.category} onChange={handleInputChange}>
                  <option value="Single">Single</option>
                  <option value="Double">Double</option>
                  <option value="Triple">Triple</option>
                </Select> */}
            <Box
              width="30%"
              display="flex"
              alignItems="center"
              boxShadow="xl"
              borderRadius="5px"
              p={4}
            >
              <FormLabel>Rate</FormLabel>
              <Input
                w="70%"
                bg="#FAFAFA"
                placeholder="Enter rate"
                name="rate"
                value={formData.rate || ""} // <-- use formData
                onChange={handleInputChange}
              />
            </Box>
            <Box
              width="30%"
              display="flex"
              alignItems="center"
              boxShadow="xl"
              borderRadius="5px"
              p={4}
            >
              <FormLabel>Discount</FormLabel>
              <Input
                w="70%"
                bg="#FAFAFA"
                placeholder="Enter Discount"
                name="discount"
                value={formData.discount}
                onChange={handleInputChange}
              />
            </Box>

            {/* <Box width="40%" display="flex" alignItems="center" boxShadow='xl' borderRadius="5px" p={4}>
                <FormLabel>Type</FormLabel>
                <Input w='70%' bg='#FAFAFA' placeholder="Enter Type" name='ac' value={formData.ac} onChange={handleInputChange} />
              </Box> */}
          </Box>
          <Box
            display="flex"
            gap="10px"
            alignItems="center"
            justifyContent="space-evenly"
          >
            {/* <Box width="30%" display="flex" alignItems="center" boxShadow='xl' borderRadius="5px" p={4}>
                <FormLabel>rate</FormLabel>
                <Input bg='#FAFAFA' placeholder="Enter rate" name='rate' value={formData.rate} onChange={handleInputChange} />
              </Box> */}
            <Box
              width="30%"
              display="flex"
              alignItems="center"
              boxShadow="xl"
              borderRadius="5px"
              p={4}
            >
              <FormLabel>CGST</FormLabel>
              <Input
                w="70%"
                bg="#FAFAFA"
                placeholder="Enter CGST rate"
                name="cgst"
                value={formData.cgst}
                onChange={handleInputChange}
              />
            </Box>
            <Box
              width="30%"
              display="flex"
              alignItems="center"
              boxShadow="xl"
              borderRadius="5px"
              p={4}
            >
              <FormLabel>SGST</FormLabel>
              <Input
                w="70%"
                bg="#FAFAFA"
                placeholder="Enter SGST rate"
                name="sgst"
                value={formData.sgst}
                onChange={handleInputChange}
              />
            </Box>
            <Box
              width="30%"
              display="flex"
              alignItems="center"
              boxShadow="xl"
              borderRadius="5px"
              p={4}
            >
              <FormLabel>Service Charge</FormLabel>
              <Input
                w="50%"
                bg="#FAFAFA"
                placeholder="Enter Service Charge"
                name="serviceCharge"
                value={formData.serviceCharge}
                onChange={handleInputChange}
              />
            </Box>
          </Box>
          <Box
            display="flex"
            gap="10px"
            alignItems="center"
            justifyContent="space-evenly"
          >
            {formData.image && formData.image.length > 0 && (
              <img src={formData.image} alt="room" />
            )}{" "}
          </Box>
        </Box>
        <Button
          type="submit"
          variant="solid"
          mr={4}
          color="#0F172B"
          bg="#42B1CD"
          _hover={{ color: "white" }}
          mt={5}
          onClick={handleSubmit}
        >
          Generate Gst Bill
        </Button>
        <Button
          type="submit"
          variant="solid"
          color="#0F172B"
          bg="#42B1CD"
          _hover={{ color: "white" }}
          mt={5}
          onClick={save}
        >
          Save
        </Button>
      </FormControl>
      {arr[0] ? (
        <Card
          mt={10}
          bg={image1}
          textAlign="center"
          boxShadow="dark-lg"
          ref={componentRef}
        >
          <Text color="purple" fontSize="18px" fontFamily="sans-serif" mt={5}>
            Room Invoice
          </Text>
          <CardHeader
            display="flex"
            justifyContent="center"
            alignItems="center"
            gap={5}
            p={4}
            boxShadow="md"
          >
            <Box>
              {printData.map((item) => (
                <Image src={item.imageUrl} w="200px" h="120px" />
              ))}
            </Box>

            <Box
              color="purple"
              fontSize="18px"
              fontFamily="sans-serif"
              bg={image1}
              textAlign="left"
            >
              {printData.map((item) => (
                <>
                  <Text>{item.name}</Text>
                  <Text>{item.adress}</Text>
                  <Text>{item.phoneNo}</Text>
                  <Text>{item.website}</Text>
                  <Text>Email id:{item.email}</Text>
                  <Text>Gst No:{item.gstNo}</Text>
                </>
              ))}
            </Box>
          </CardHeader>
          <Box p={4} textAlign="left">
            <SimpleGrid columns={3} spacing={4} p={4}>
              {arr.map(([key, value]) => (
                <CardBody borderRadius="5px" p={4}>
                  <Text color="purple" fontSize="15px" fontFamily="sans-serif">
                    {key[0].toUpperCase() + key.slice(1)}--{value}
                  </Text>
                </CardBody>
              ))}
            </SimpleGrid>
          </Box>
          <CardFooter
            display="flex"
            justifyContent="space-between"
            p={25}
            textAlign="left"
          >
            <Box color="purple" fontSize="15px" fontFamily="sans-serif">
              {printData.map((item) => (
                <>
                  <Text>A/C NO - {item.acNo}</Text>
                  <Text>IFSC CODE - {item.ifsc}</Text>
                  <Text>BRANCH - {item.branch}</Text>
                  <Text>CONTACT NO - {item.phoneNo}</Text>

                  <Text>Front Office Signature</Text>
                  <Text>Date-</Text>
                </>
              ))}
            </Box>
            <Box mr={20} color="purple" fontSize="15px" fontFamily="sans-serif">
              <Text>Guest Signature</Text>
              <Text>Date-</Text>
            </Box>
          </CardFooter>
        </Card>
      ) : (
        ""
      )}
      {arr[0] ? (
        <Button
          type="submit"
          variant="solid"
          color="#0F172B"
          bg="#42B1CD"
          _hover={{ color: "white" }}
          mt={5}
          onClick={handlePrint}
        >
          Print
        </Button>
      ) : (
        ""
      )}
    </Box>
  );
};

export default RoomBilling;
